exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Invite-module__wrapper___2I4QH{background-color:#0827e9;color:#fff;border-radius:17px;display:grid;gap:1rem;justify-content:center;align-items:center;padding:1rem;height:250px}.Invite-module__wrapper___2I4QH.Invite-module__reflection___PI3mB{background-color:#8450f8}.Invite-module__wrapper___2I4QH h2{text-align:center}.Invite-module__wrapper___2I4QH .Invite-module__items___3r5xV{align-items:center}.Invite-module__wrapper___2I4QH .Invite-module__buttons___1XTgW,.Invite-module__wrapper___2I4QH .Invite-module__items___3r5xV{display:grid;gap:.5rem;grid-auto-flow:column;justify-content:center}", ""]);

// exports
exports.locals = {
	"wrapper": "Invite-module__wrapper___2I4QH",
	"reflection": "Invite-module__reflection___PI3mB",
	"items": "Invite-module__items___3r5xV",
	"buttons": "Invite-module__buttons___1XTgW"
};